// extracted by mini-css-extract-plugin
module.exports = {"container":"RecoveredStories_container__3xSxd"};